export enum ROLES {
  ADMIN = 'admin',
  VIEW = 'view',
  ADV_GEO_VIEW = 'adv.geo.view',
  ADV_CAMPAIGN_VIEW = 'adv.campaign.view',
  ADV_CAMPAIGN_ORG_VIEW = 'adv.campaign.org.view',
  ADV_ORG_EDIT = 'adv.org.edit',
  ADV_AD_SURFACETYPE_NEW = 'adv.ad.surfaceType.new',
  DEVICE_PARK_VIEW = 'device.park.view',
  DEVICE_OPERATOR_VIEW = 'device.operator.view',
  DEVICE_SURFACETYPE_VIEW = 'device.surfaceType.view',
  DEVICE_EDIT = 'device.edit',
  DEVICE_NEW = 'device.new',
  DEVICE_PROFILE_NEW = 'device.profile.new',
  DEVICE_SSH_EDIT = 'device.ssh.edit',
  DEVICE_SCREEN_EDIT = 'device.screen.edit',
  DEVICE_BOOTSTRAPPED_EDIT = 'device.bootstrapped.edit',
  DEVICE_BOOTSTRAPPED_PROFILE_EDIT = 'device.bootstrapped.profile.edit',
  STAT_VIEW = 'stat.view',
  STAT_BASIC_DEVICE_PROFILE_VIEW = 'stat.basic.device.profile.view',
  STAT_DEVICE_PROFILE_VIEW = 'stat.device.profile.view',
  STAT_CAMPAIGN_ORG_VIEW = 'stat.campaign.org.view',
  STAT_STATIC_ADV_ORG_VIEW = 'stat.staticAdv.org.view',
  INCIDENT_VIEW = 'incident.view',
  PARK_VIEW = 'park.view',
  OPERATOR_VIEW = 'operator.view',
  DEVICE_PROFILE_VIEW = 'device.profile.view',
  FORMS_INSTALL_STATIC_DEVICE_SUBMIT = 'forms.installDevice.static.submit',
  FORMS_INSTALL_DIGITAL_BOX_SUBMIT = 'forms.installDevice.dynamic.submit',
  FORMS_INSTALL_GPS_TRACKER_SUBMIT = 'forms.installDevice.gpsTracker.submit',
  FORMS_INSTALL_BOX_ADV_SUBMIT = 'forms.installBoxAdv.submit',
  FORMS_INSTALL_SIDES_ADV_SUBMIT = 'forms.installSidesAdv.submit',
  FORMS_INSTALL_DEVICE_TABLE_SUBMIT = 'forms.installDevice.tablet.submit',
  FORMS_REMOVE_DEVICE_DYNAMIC_SUBMIT = 'forms.removeDevice.dynamic.submit',
  FORMS_REMOVE_DEVICE_STATIC_SUBMIT = 'forms.removeDevice.static.submit',
  FORMS_REMOVE_DEVICE_GPS_TRACKER_SUBMIT = 'forms.removeDevice.gpsTracker.submit',
  FORMS_REMOVE_DEVICE_TABLET_SUBMIT = 'forms.removeDevice.tablet.submit',
  FORMS_REMOVE_DEVICE_REMOVE_BOX_ADV_SUBMIT = 'forms.removeBoxAdv.submit',
  FORMS_REMOVE_DEVICE_REMOVE_SIDES_ADV_SUBMIT = 'forms.removeSidesAdv.submit',
  STATIC_ADV_ORG_VIEW = 'staticAdv.org.view',
  STATIC_ADV_ORG_EDIT = 'staticAdv.org.edit',
  DEVICE_STATIC_ADV_ORG_VIEW = 'device.staticAdv.org.view',
  DEVICE_TAGS_EDIT = 'device.tags.edit',
  DEVICE_TAGS_PARK_EDIT = 'device.tags.park.edit',
  DEVICE_TAGS_OPERATOR_EDIT = 'device.tags.operator.edit',
  DEVICE_TAGS_PROFILE_EDIT = 'device.tags.profile.edit',
  ADV_CAMPAIGN_TAGS_EDIT = 'adv.campaign.tags.edit',
  ADV_CAMPAIGN_TAGS_ORG_EDIT = 'adv.campaign.tags.org.edit',
  ADV_ADMIN_MOD_EDIT = 'adv.adminMod.edit',
  ADV_ADMIN_MOD_ORG_EDIT = 'adv.adminMod.org.edit',
  SURFACE_TYPE_VIEW = 'surfaceType.view',
  PROFILE_VIEW = 'profile.view',
  ORG_VIEW = 'org.view',
  // не используемые роли но добавлены для коректной валидации
  CAMPAIGN_PRIORITIES_VIEW = 'campaignPriorities.view',
  ADV_AD_VIEW = 'adv.ad.view',
  ADV_CAMPAIGN_EDIT = 'adv.campaign.edit',
  ADV_GEO_EDIT = 'adv.geo.edit',
  DEVICE_VIEW = 'device.view',
  GLOBALS_VIEW = 'globals.view',
  STATIC_ADV_VIEW = 'staticAdv.view',
  USER_VIEW = 'user.view',
  STAT_STATIC_ADV_VIEW = 'stat.staticAdv.view',
  STAT_DEVICE_VIEW = 'stat.device.view',
  STAT_CAMPAIGN_VIEW = 'stat.campaign.view',
  REPORT_VIEW = 'reports.view',
  REPORT_EDIT = 'reports.edit',
  PROFILE_EDIT = 'profile.briProfile.edit',
}

export interface IRole {
  id: ROLES,
  objects?: string [],
}

export interface IUser {
  id: string,
  email: string,
  roles: IRole [],
  comment?: string,
  tg_link?: string,
  tg_link_exp?: number,
  tg_id?: number,
  last_login_at?: number,
}

export interface UserCreateBody extends IUser {
  password: string,
}

export interface UserUpdateBody extends Omit<IUser, 'email'> {
  password?: string,
}

export interface PermissionsRequestBody {
  type: 'validate' | 'resolve';
  role: ROLES | string,
  objects?: string[],
}

export type PermissionsResponse = boolean[] | string[];
